const colors = {
  primary: {
    blue: 'rgba(48,137,243,1)',
    green: '#71D77C'
  },
  ui: {
    borderGray: 'rgba(226,228,231,1)',
    // borderGray: '#e2e4e7',
    grayContent: '#F7F9FB',
    errorRed: 'rgba(237,73,73,1)',
    headerGray: '#262626',
    buttonBorder: '#C8C8CC',
    activeHightlight: '#daeafd'
  },
  text: {
    input: '#88939a',
    label: '#40505A',
    subtleGray: '#88939a',
    pronouncedGray: '#7d7d7d',
    buttonGray: '#a0a6ad',
    darkGray: '#262626',
    modalSubGray: '#d3d5d6',
  }
}

export default colors
